import { useEffect, useState } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";

import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function ExitIntentModal({ children }) {

    return (
        <ThemeProvider theme={mainTheme}>
            <div>
                Content Here
            </div>
            <ExitModal cookieSkip={true}>
                <div style={{backgroundColor:"peachpuff", padding:"30px"}}>
                This is some modal content
                <FormMini buttonText="Subscribe" formName="es2_blog" listId="147953" />
                </div>
            </ExitModal>
        </ThemeProvider>
    );
}